import React from "react";
import { connect } from "react-redux";
import { addAnswer, clearAnsweres } from "../../../../redux/survey/actions";
import { useIntl } from "react-intl";
import DropdownComponent from "../Components/DropdownComponent";

const Dropdown = (props) => {
  // Destructure props for easier access
  const { question, answeres, addAnswer_, hasError } = props;
  const intl = useIntl();

  // Function to retrieve answer for the current question
  let answer = () => {
    // Check if question ID exists in answers
    if (!(question._id in answeres)) {
      return { value: "" }; // If not, return empty value
    } else {
      if (!("value" in answeres[question._id])) {
        return { value: "" }; //  If answer doesn't have a value property, return empty value
      } else {
        return answeres[question._id]; // Otherwise, return the answer
      }
    }
  };

  const handleChange = async (value) => {
    // Add answer to Redux state
    await addAnswer_({
      id: question._id,
      value: value,
      type: "id",
    });
  };

  return (
    <DropdownComponent
      options={question.options}
      selectedValue={answer().value}
      onChange={handleChange}
      placeholder={intl.formatMessage({ id: "please-select" })}
      noOptionsText={intl.formatMessage({ id: "no-results-found" })}
      id="demo-select-small"
      hasError={hasError}
    />
  );
};
// Map Redux state to component props
const mapStateToProps = (state) => {
  return {
    answeres: state.survey.answeres,
  };
};
// Map Redux dispatch functions to component props
const mapDispatchToProps = (dispatch) => {
  return {
    addAnswer_: (data) => dispatch(addAnswer(data)),
    clearAnsweres_: () => dispatch(clearAnsweres()),
  };
};
// Connect component to Redux store
export default connect(mapStateToProps, mapDispatchToProps)(Dropdown);
